const startUnsubscribeJob = async (formValues) => {
  try {
    const response = await fetch(
      '/api/shopify/customer/account/startUnsubscribeJob',
      {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          formValues
        })
      }
    );

    const data = await response.json();

    if (!response.ok) {
      return { success: false, data };
    }

    return { success: true, data };
  } catch (error) {
    console.error(
      'Error unsubscribing and updating Shopify customer information:',
      error
    );
    return { success: false, error };
  }
};

export { startUnsubscribeJob };
